import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { errorToast, successToast } from 'helpers';
import i18n from 'locales/i18n';
import {
  SelectedShop,
  ShopSettingTypes,
  RequestParams,
  NoteAppRankingTypes,
  itemInputOrderByImgSlideRank,
} from 'models';

export interface LoginPayload {
  email: string;
  password: string;
  role: number;
  remember_me: boolean;
}

interface InitialState {
  orderByRankingInPosRanking: any;
  hostForOrderList: {
    data: [];
    shopId: null;
  };
  imageSlide: any;
  rankingPublic: any;
  rankingPublicGroupShop: Array<any>;
  rankingPublicMonthGroupShop: Array<any>;
  rankingNearestPublic: any;
  rankingMonthPublic: any;
  noteAppRanking: NoteAppRankingTypes[];
  imageShowRank: [];
  dayHaveData: any;
  userStaff: any;
  orderByImagesSliderRank: any;
  orderByImagesSliderRankLoading: boolean;
  loading: false;
  error: null;
  noteStaffAppRanking: any[];
  programRank: any;
  programRankLoading: boolean;
  notePositionAppRanking: NoteAppRankingTypes[];
  loadingRankingDate: boolean;
  addMediaLoading: boolean;
}

const initialState: InitialState = {
  rankingPublic: [],
  rankingNearestPublic: [],
  rankingMonthPublic: [],
  orderByRankingInPosRanking: [],
  hostForOrderList: {
    data: [],
    shopId: null,
  },
  rankingPublicGroupShop: [],
  rankingPublicMonthGroupShop: [],
  imageSlide: [],
  noteAppRanking: [] as NoteAppRankingTypes[],
  imageShowRank: [],
  dayHaveData: [],
  userStaff: {},
  orderByImagesSliderRank: [],
  orderByImagesSliderRankLoading: true,
  loading: false,
  error: null,
  noteStaffAppRanking: [],
  programRank: [],
  programRankLoading: true,
  notePositionAppRanking: [] as NoteAppRankingTypes[],
  loadingRankingDate: false,
  addMediaLoading: false,
};

const rankingSlice = createSlice({
  name: 'ranking',
  initialState,
  reducers: {
    fetchOrderByRankingInPosRanking(
      state,
      action: PayloadAction<{ token: string; params: { shop_id?: number; permission?: string } }>
    ) {},

    fetchOrderByRankingInPosRankingSuccess(state: any, action: PayloadAction<any>) {
      state.orderByRankingInPosRanking = action.payload;
    },
    deleteImageSlider(
      state,
      action: PayloadAction<{
        token: string;
        id: any;
        data: { shop_id?: any; shop_ids?: Array<number> };
        onSuccess?: () => void;
      }>
    ) {},

    deleteImageSliderSuccess(state: any, action: PayloadAction<any>) {
      const { id } = action.payload;
      state.imageSlide = state.imageSlide?.filter((x: any) => x.id !== id);
    },
    updateImageSettingAvatarRanking(
      state,
      action: PayloadAction<{
        token: string;
        data: { shop_id: number | undefined; imageFile: any; id: any; delete_avatar_ranking?: any };
      }>
    ) {},
    updateImageSettingAvatarRankingSuccess(state: any, action: PayloadAction<any>) {
      state.userStaff = action.payload;

      state.hostForOrderList.data = state.hostForOrderList.data.map((item: any) =>
        item.id === action.payload.id ? action.payload : item
      );
    },

    // updateImageSettingAvatarRankingSuccess(state: any, action: PayloadAction<any>) {
    //   state.userStaff = action.payload;

    // },
    fetchHostForOrderList(
      state,
      action: PayloadAction<{
        token: string;
        params: {
          shopId: number;
          is_host?: any;
          key?: any;
          status?: any;
          group_id?: any;
          per_page: 1000;
        };
      }>
    ) {},

    fetchHostForOrderListSuccess(state: any, action: PayloadAction<any>) {
      state.hostForOrderList = action.payload;
    },

    updateOrderByRankingInPosRanking(state, action: PayloadAction<{ token: string; data: any }>) {},

    updateOrderByRankingInPosRankingSuccess(state: any, action: PayloadAction<any>) {
      state.orderByRankingInPosRanking = action.payload;
    },
    addImageSlider(state, action: PayloadAction<{ token: string; data: any }>) {
      state.addMediaLoading = true;
    },
    addStandByMedia(
      state,
      action: PayloadAction<{
        token: string;
        listMedia: Array<{
          imageFile: any;
          order_by: number;
          shop_id?: number;
          shop_ids?: Array<number>;
        }>;
      }>
    ) {
      state.addMediaLoading = true;
    },
    addStandByMediaSuccess(state, action: PayloadAction<Array<any>>) {
      state.imageSlide = [...state.imageSlide, ...action.payload];
      state.addMediaLoading = false;
      successToast(i18n.t('ADD_MEDIA_SUCCESS'));
    },
    addStandByMediaFailed(state) {
      state.addMediaLoading = false;
      errorToast(i18n.t('ADD_MEDIA_ERROR'));
    },
    updateImageSlider(
      state,
      action: PayloadAction<{
        token: string;
        data: { shop_id?: number | undefined; shop_ids?: Array<number>; order_by?: any };
      }>
    ) {},
    updateImageSliderSuccess(state: any, action: PayloadAction<any>) {},
    addImageSliderSuccess(state: any, action: PayloadAction<any>) {
      state.addMediaLoading = false;
      state.imageSlide.push(action.payload);
    },
    addImageSliderFailed(state: any) {
      state.addMediaLoading = false;
    },
    getImageSlider(state, action: PayloadAction<{ token: string; params: any }>) {},

    getImageSliderSuccess(state: any, action: PayloadAction<any>) {
      state.imageSlide = action.payload;
    },
    getRankingPublicRequest: (state: any) => {
      state.loading = true;
    },
    getRankingPublic(state: any, action: PayloadAction<any>) {},

    getRankingPublicSuccess: (state, action: PayloadAction<any[]>) => {
      state.rankingPublic = action.payload;
    },
    getRankingPublicGroupShop(state: any, action: PayloadAction<any>) {},

    getRankingPublicGroupShopSuccess: (state, action: PayloadAction<any[]>) => {
      state.rankingPublicGroupShop = action.payload;
    },
    getRankingPublicGroupShopFailed: (state) => {
      state.rankingPublicGroupShop = initialState.rankingPublicGroupShop;
    },
    getRankingPublicGroupShopMonth(state: any, action: PayloadAction<any>) {},

    getRankingPublicGroupShopMonthSuccess: (state, action: PayloadAction<any[]>) => {
      state.rankingPublicMonthGroupShop = action.payload;
    },
    getRankingPublicGroupShopMonthFailed: (state) => {
      state.rankingPublicMonthGroupShop = initialState.rankingPublicMonthGroupShop;
    },
    getRankingPublicComplete: (state: any) => {
      state.loading = false;
    },
    getRankingPublicFailure: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.loading = false;
    },
    getRankingPublicMonthRequest: (state: any) => {
      state.loading = true;
    },
    getRankingMonthPublic(state: any, action: PayloadAction<any>) {
      state.loading = true;
    },

    getRankingPublicMonthSuccess(state: any, action: PayloadAction<Array<any>>) {
      state.rankingMonthPublic = action.payload;
      state.loading = false;
    },
    getRankingPublicMonthFailure: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateImageShowRanking(
      state,
      action: PayloadAction<{
        token: string;
        data: { shop_id: number | undefined; imageFile: any; user_id: any };
      }>
    ) {},
    updateImageShowRankingSuccess(state: any, action: PayloadAction<any>) {
      state.imageShowRank = action.payload;
    },

    getNoteAppRanking(
      _state: any,
      _action: PayloadAction<{
        token: string;
        params: { shop_id?: string; permission?: string; program_rank_id?: number; type?: number };
      }>
    ) {},

    getNoteAppRankingSuccess(state: any, action: PayloadAction<NoteAppRankingTypes[]>) {
      if (!Array.isArray(action.payload)) return;
      const existing = state.noteAppRanking || [];

      const merged = [
        ...existing,
        ...action.payload.filter(
          (item) => !existing.some((e: any) => e.shop_id === item.shop_id && e.rank === item.rank)
        ),
      ];

      state.noteAppRanking = merged;
    },
    getNoteAppRankingFailed(state) {
      state.noteAppRanking = [];
    },
    getNotePositionAppRanking(
      _state: any,
      _action: PayloadAction<{ token: string; params: { shop_id: string } }>
    ) {},

    getNotePositionAppRankingSuccess(state: any, action: PayloadAction<NoteAppRankingTypes[]>) {
      if (!Array.isArray(action.payload)) return;

      const existing = state.notePositionAppRanking || [];

      const merged = [
        ...existing,
        ...action.payload.filter(
          (item) => !existing.some((e: any) => e.shop_id === item.shop_id && e.rank === item.rank)
        ),
      ];

      state.notePositionAppRanking = merged;
    },
    getNoteStaffAppRanking(
      _state: any,
      _action: PayloadAction<{ token: string; params: { shop_id: string; type: number } }>
    ) {},

    getNoteStaffAppRankingSuccess(state: any, action: PayloadAction<NoteAppRankingTypes[]>) {
      state.noteStaffAppRanking = action.payload;
    },

    updateNoteAppRanking(_state: any, _action: PayloadAction<{ token: string; data: any }>) {},

    updateNoteAppRankingSuccess(state: any, action: PayloadAction<any>) {
      for (const item of action.payload) {
        const findIndex = state.noteStaffAppRanking.findIndex((i: any) => i?.id === item?.id);
        if (findIndex !== -1) {
          state.noteStaffAppRanking[findIndex] = item;
        }
      }
    },
    getImageShowRanking(
      _state: any,
      _action: PayloadAction<{ token: string; params: { shop_id: any; user_id: number } }>
    ) {},
    getImageShowRankingSuccess(state: any, action: PayloadAction<any>) {
      state.imageShowRank = action.payload;
    },
    getDateHaveDataRanking(
      _state: any,
      _action: PayloadAction<{ token: string; params: { shop_id: string } }>
    ) {},
    getDateHaveDataRankingSuccess(
      state: any,
      action: PayloadAction<{
        shop_id: Number;
        data: Array<{ date: string; count: number }>;
      }>
    ) {
      const { shop_id, data } = action.payload;
      if (!shop_id || !Array.isArray(data)) return;

      let shopData = state.dayHaveData.find((item: any) => item.shop_id === shop_id);

      if (!shopData) {
        shopData = {
          shop_id,
          dates: [],
        };
        state.dayHaveData.push(shopData);
      }

      // merge dates
      data.forEach(({ date, count }) => {
        const existedDate = shopData.dates.find((d: any) => d.date === date);

        if (existedDate) {
          existedDate.count += count;
        } else {
          shopData.dates.push({ date, count });
        }
      });
    },
    getDateHaveDataRankingFailure(state) {
      state.dayHaveData = [];
    },
    getRankingNearestDayPublic(state: any, action: PayloadAction<any>) {
      state.loading = true;
    },
    getRankingNearestDaySuccess: (state, action: PayloadAction<any[]>) => {
      state.rankingNearestPublic = action.payload;
      state.loading = false;
    },
    getRankingNearestDayFailed(state: any) {
      state.loading = false;
    },
    getOrderByImagesSLiderRanking(
      state,
      _action: PayloadAction<{
        token: string;
        params: { shop_id?: number; permission?: string; program_rank_id?: number };
      }>
    ) {
      state.orderByImagesSliderRankLoading = true;
    },
    toggleOrderByImagesSliderRankingLoading(state, action: PayloadAction<boolean>) {
      state.orderByImagesSliderRankLoading = action.payload;
    },
    getOrderByImagesSLiderRankingSuccess(state: any, action: PayloadAction<any>) {
      state.orderByImagesSliderRank = action.payload;
      state.orderByImagesSliderRankLoading = false;
    },
    getOrderByImagesSLiderRankingFailed(state) {
      state.orderByImagesSliderRank = [];
      state.orderByImagesSliderRankLoading = false;
    },
    resetOrderByImagesSLiderRanking(state) {
      state.orderByImagesSliderRank = [];
    },
    updateOrderByImagesSliderRanking(
      state,
      action: PayloadAction<{
        token: string;
        data: {
          shop_id?: number | undefined;
          shop_ids?: Array<number>;
          input: itemInputOrderByImgSlideRank[];
          type_update?: number;
        };
      }>
    ) {},

    updateOrderByImagesSliderRankingSuccess(state: any, action: PayloadAction<any>) {
      state.orderByImagesSliderRank = action.payload;
    },
    deleteOrderByImagesSliderRanking(
      state,
      action: PayloadAction<{
        token: string;
        data: { shop_id?: number | undefined; type_delete?: number };
        id: number;
      }>
    ) {},
    deleteOrderByImagesSliderRankingSuccess(state: any, action: PayloadAction<any>) {
      state.orderByImagesSliderRank = state.orderByImagesSliderRank?.filter(
        (x: any) => x.id !== action.payload
      );
    },
    getProgramRank(
      state,
      _action: PayloadAction<{ token: string; params: { shop_id?: number; permission?: string } }>
    ) {
      state.programRankLoading = true;
    },

    getProgramRankSuccess(state: any, action: PayloadAction<any>) {
      state.programRank = action.payload;
      state.programRankLoading = false;
    },
    getProgramRankFailed(state) {
      state.programRank = [];
      state.programRankLoading = false;
    },
    createProgramRank(
      state,
      action: PayloadAction<{
        token: string;
        data: { shop_id?: number | undefined; name: string; shop_ids?: Array<number> };
      }>
    ) {},
    createProgramRankSuccess(state: any, action: PayloadAction<any>) {
      // 22/10 disable append data into state
      if (Array.isArray(action.payload)) {
        state.programRank = [...(state.programRank || []), action.payload[0]];
      } else {
        state.programRank = [...(state.programRank || []), action.payload];
      }
    },
    updateProgramRank(
      state,
      action: PayloadAction<{
        token: string;
        id: number;
        data: {
          shop_id?: number | undefined;
          active?: number | undefined;
          layout_screen?: number | undefined;
          shop_ids?: Array<number>;
        };
      }>
    ) {},

    updateProgramRankSuccess(state, action: PayloadAction<any>) {
      const index = state.programRank.findIndex((x: any) => x?.id === action.payload?.id);
      if (index !== -1) {
        if (action.payload.active === 1) {
          state.programRank = state.programRank.map((item: any, idx: number) =>
            idx === index ? { ...action.payload, active: 1 } : { ...item, active: null }
          );
        } else {
          state.programRank[index] = { ...action.payload };
        }
      }
    },
    updateNoteWithOptionRank(_state: any, _action: PayloadAction<{ token: string; data: any }>) {},

    updateNoteWithOptionRankSuccess(_state: any, _action: PayloadAction<any>) {
      for (const item of _action.payload) {
        const findIndex = _state.noteAppRanking.findIndex(
          (i: any) =>
            i?.rank === item?.rank &&
            (i?.order_by_image_slider_ranking_id === item?.order_by_image_slider_ranking_id ||
              i?.order_by_images_slider_ranking?.order_by_ranking_id ===
                item?.order_by_images_slider_ranking?.order_by_ranking_id)
        );
        if (findIndex !== -1) {
          _state.noteAppRanking[findIndex] = { ...item };
        } else {
          _state.noteAppRanking = [..._state.noteAppRanking, item];
        }
      }
    },
    setLoadingRankingDate(state, action: PayloadAction<any>) {
      state.loadingRankingDate = action.payload;
    },
    getRankingPublicDate(state: any, action: PayloadAction<any>) {},

    getRankingPublicDateSuccess: (state, action: PayloadAction<any[]>) => {
      state.rankingPublic = action.payload;
    },
    deleteProgramRank(
      state,
      action: PayloadAction<{ token: string; id: number; data: { shop_id: number | undefined } }>
    ) {},

    deleteProgramRankSuccess(state, action: PayloadAction<any>) {
      state.programRank = state.programRank.filter((x: any) => x.id !== action.payload.id);
    },
  },
});

// Actions
export const rankingAction = rankingSlice.actions;
// Selectors
export const selectRanking = (state: any) => state.ranking;

// Reducer
const rankingReducer = rankingSlice.reducer;
export default rankingReducer;
